import React from 'react'
import { useIsPortal } from 'utils/Subscription/PermissionSelector'
import { useIsTyresOrderAccount } from 'app/products/hooks/use-is-tyres-orderaccount'
import { ESearchFilterValue, IMenuItem } from '@cbgms/components/src/top-search/topSearchUtils'
import { useFeature } from '@cbgms/base/feature-flags'

import { ResultObjectType } from '@cbgms/api'
import SupplierPartIcon from '@carsys/ui/src/icons/SupplierPartIcon'
import SearchAllIcon from '@carsys/ui/src/icons/SearchAllIcon'
import B2BOrderIcon from '@carsys/ui/src/icons/B2BOrderIcon'
import VehicleIcon from '@carsys/ui/src/icons/VehicleIcon'
import { TyreIcon } from '@carsys/ui/src/icons/TyreIcon'
import QuotationIcon from '@carsys/ui/src/icons/QuotationIcon'
import WorkorderIcon from '@carsys/ui/src/icons/WorkorderIcon'
import InvoiceIcon from '@carsys/ui/src/icons/InvoiceIcon'
import AccountIcon from '@carsys/ui/src/icons/AccountIcon'

export const portalMenuItems: IMenuItem[] = [
  { value: ESearchFilterValue.AllPortal, translateKey: 'search-filter.all_categories', icon: <SearchAllIcon /> },
  { value: ESearchFilterValue.Vehicles, translateKey: 'search-filter.vehicles', icon: <VehicleIcon /> },
  { value: ESearchFilterValue.Order, translateKey: 'search-filter.external-orders', icon: <B2BOrderIcon /> },
  { value: ESearchFilterValue.Parts, translateKey: 'search-filter.parts', icon: <SupplierPartIcon /> },
  { value: ESearchFilterValue.Account, translateKey: 'search-filter.accounts', icon: <AccountIcon /> },
  { value: ESearchFilterValue.Tyres, translateKey: 'search-filter.tyres', icon: <TyreIcon /> }
]

export const gmsMenuItems: IMenuItem[] = [
  { value: ESearchFilterValue.AllGMS, translateKey: 'search-filter.all_categories', icon: <SearchAllIcon /> },
  { value: ESearchFilterValue.Vehicles, translateKey: 'search-filter.vehicles', icon: <VehicleIcon /> },
  { value: ESearchFilterValue.Quotations, translateKey: 'search-filter.quotations', icon: <QuotationIcon /> },
  { value: ESearchFilterValue.WorkOrder, translateKey: 'search-filter.workorders', icon: <WorkorderIcon /> },
  { value: ESearchFilterValue.Order, translateKey: 'search-filter.external-orders', icon: <B2BOrderIcon /> },
  { value: ESearchFilterValue.Account, translateKey: 'search-filter.accounts', icon: <AccountIcon /> },
  { value: ESearchFilterValue.Invoice, translateKey: `Enum.EnumResultObjectType_${ResultObjectType.Invoice}`, icon: <InvoiceIcon /> }
]

export const useSearchMenuOptions = () => {
  const isPortal = useIsPortal()
  const hasTyres = useIsTyresOrderAccount()
  const isV2 = useFeature('b2b-design-v2')
  const menuOptions = React.useMemo(() => {
    let items = isPortal ? portalMenuItems : gmsMenuItems
    if (!hasTyres) {
      items = items.filter(opt => opt.value !== ESearchFilterValue.Tyres)
    }

    // rename 'all categories' to just 'all' for version 1. once 'b2b-design-v2' is removed, there's not need for this anymore
    items = items.map(a => ({
      ...a,
      translateKey: !isV2 && a.translateKey === 'search-filter.all_categories' ? 'search-filter.all' : a.translateKey
    }))
    return items
  }, [isPortal, hasTyres, isV2])

  return menuOptions
}
